module.exports = __webpack_public_path__ + "img/battles.6ac50e84.png";